import React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";
import { colors, radii, shadowStyles } from "../../../../styles/design-system";

interface TableContainerProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export function TableContainer({ children, style }: TableContainerProps) {
  return <View style={[styles.container, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: colors.white,
    borderRadius: radii.lg,
    borderWidth: 1,
    borderColor: colors.grey[200],
    overflow: "visible",
    ...shadowStyles.sm,
  },
});
